import styles from "./taskfilter.module.css";
import { Search } from "react-feather";

const TaskFilter = ({ setFilterData }) => {
  return (
    <div className={`${styles.SearchFilterSec}`}>
      <div className={`${styles.SearchCon}`}>
        <div className={`${styles.SearchConSec}`}>
          <Search />
          <input
            type="text"
            placeholder="Search"
            onChange={(e) =>
              setFilterData((prev) => {
                return { ...prev, searchKey: e.target.value };
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default TaskFilter;
